<template>
  <div ref="formPanel">
    <div class="card">
      <div class="card-body">
        <h5 class="mb-3">
          <i class="icon-checkmark2 text-muted"></i>
          {{ title }}
        </h5>
        <form>
          <div class="row">
            <div class="col">
              <TextBox
                :placeholder="$helper.getWord('wf_name')"
                v-model="filter.wf_name"
                :nolabel="true"
              />
            </div>
            <div class="col">
              <TextBox
                :placeholder="$helper.getWord('wf_version')"
                v-model="filter.wf_version"
                :nolabel="true"
              />
            </div>
            <div class="col">
              <TextBox
                :placeholder="$helper.getWord('action_name')"
                v-model="filter.name"
                :nolabel="true"
              />
            </div>
            <div class="col">
              <TextBox
                :placeholder="$helper.getWord('action_description')"
                v-model="filter.description"
                :nolabel="true"
              />
            </div>
            <div class="col">
              <TextBox
                :placeholder="$helper.getWord('receiver')"
                v-model="filter.receiver"
                :nolabel="true"
              />
            </div>
          </div>
          <div class="row">
            <div class="col-sm-2">
              <CheckBox
                v-model="isLatestVersion"
                :nolabel="true"
                :options="[{ Key: true, Value: 'Latest Version'}]"
              />
            </div>
            <div class="col-sm-2">
              <CheckBox
                v-model="isShowSelected"
                :nolabel="true"
                :options="[{ Key: true, Value: 'Show Selected'}]"
              />
            </div>
          </div>
          <div class="navbar navbar-light navbar-expand-lg shadow-0 py-lg-2 pl-0 rounded-top">
            <div class="mt-3 mt-lg-0 mr-lg-3">
              <button type="button" @click="getData()" class="btn btn-primary legitRipple mr-2">
                <i class="fas fa-search mr-2"></i>
                {{ $helper.getWord("Filter") }}
              </button>
              <button
                type="button"
                @click="clearFilter()"
                class="btn bg-slate-300 legitRipple mr-2"
              >
                <i class="fas fa-trash mr-2"></i>
                {{ $helper.getWord("CLEAR") }}
              </button>
              <button
                v-if="selecteds"
                type="button"
                @click="applyRecord()"
                class="btn bg-teal-400 legitRipple mr-2"
              >
                <i class="fas fa-check-square mr-2"></i>
                {{ $helper.getWord("APPLY") }}
              </button>
            </div>
          </div>
          <div>
            {{ selecteds.length }} action{{
            selecteds.length > 1 ? "s" : ""
            }}
            selected.
          </div>
        </form>
      </div>
    </div>
    <div class="card">
      <div class="card-body">
        <ul class="media-list" style=" list-style: none;
  padding-left: 0;
  margin-bottom: 0;">
          <template v-for="(d, i) in tableData" v-if="notInExclude(d)">
            <li
              :key="'h' + i"
              v-if="i === 0 || d.wf_name !== tableData[i - 1].wf_name"
              class="media font-weight-semibold py-1"
            >{{ d.wf_name || $helper.getWord("") }}</li>
            <li
              :key="'r' + i"
              class="media"
              :class="{ selected: isSelected(d.id) }"
              @click="selectRecord(d, $event)"
            >
              <div class="mr-3">
                <div class="list-icons list-icons-extended">
                  <span class="list-icons-item">
                    <i class="fas fa-check"></i>
                  </span>
                </div>
              </div>
              <div class="unselectable">
                <div class="media-title font-weight-semibold">{{ d.name }} - {{d.receiver}}</div>
                <span class="text-muted" v-html="formatEntity(d)"></span>
              </div>
            </li>
          </template>
        </ul>
      </div>
    </div>
    <!-- Pagination -->
    <div class="d-flex justify-content-center pt-3 mb-3">
      <ul class="pagination shadow-1">
        <li class="page-item" :class="{ disabled: currentPage === 0 }">
          <a
            @click="getData(Math.max(currentPage - pagingPages, 0))"
            class="page-link page-link-white legitRipple"
          >
            <i class="fas fa-angle-left"></i>
          </a>
        </li>
        <li v-for="i in pages" :key="i" class="page-item" :class="{ active: i === currentPage + 1}">
          <a @click="getData(i - 1)" class="page-link page-link-white legitRipple">{{ i }}</a>
        </li>
        <li
          class="page-item"
          :class="{ disabled: currentPage === Math.ceil(totalRecords / pageSize) - 1 }"
        >
          <a
            @click="getData(Math.min(currentPage + pagingPages, pages.length - 1))"
            class="page-link page-link-white legitRipple"
          >
            <i class="fas fa-angle-right"></i>
          </a>
        </li>
      </ul>
    </div>
    <!-- /pagination -->
  </div>
</template>
<script>
import api from "@/api";
import config from "@/config";
import SelectBox from "@/components/selectbox";
import TextBox from "@/components/textbox";
import helper from "@/vueHelper";

export default {
  name: "WfPicker",
  props: [
    "id",
    "titleText",
    "value",
    "multiple",
    "includeSelf",
    "form",
    "excludeUsers",
    "delayLoad",
    "inDialog",
    "includeUsers",
    "defaultSelect"
  ],
  components: { TextBox, SelectBox },
  data() {
    return {
      filter: {},
      lookups: {},
      tableData: [],
      totalRecords: 0,
      pageSize: config.tablePageLength,
      pagingPages: 20,
      selecteds: [],
      currentPage: 0,
      isInit: false,
      allowMultiple: this.multiple || false,
      title: this.titleText || "Select Workflow Action",
      isLatestVersion: true,
      isShowSelected: false
    };
  },
  mounted() {
    if (this.delayLoad !== true) {
      this.getData();
    }
    if (this.delayLoad === true) {
      $(this.$parent.$refs.modal).on("shown.bs.modal", () => {     
        this.getData();
      });
    }
    this.setSelected(this.value);
  },
  methods: {
    getData(page) {
      if (this.currentPage === page) return;

      this.showLoading();

      this.currentPage = Math.max(page || 0, 0);

      api.request(
        this,
        "post",
        "/workflow/getWfPicker",
        {
          SessionID: helper.getSessionID(),
          LocaleCode: helper.getLocaleCode(),
          Parameters: {
            includeSelf: this.includeSelf || false,
            excludeUsers: this.excludeUsers || [],
            includeUsers: this.includeUsers || [],
            form: this.form,
            currentPage: this.currentPage,
            pageSize: this.pageSize,
            filter: this.filter,
            isLatestVersion: this.isLatestVersion
          }
        },
        function(r) {
          this.lookups = r.data.lookups;
          this.tableData = r.data.tableData;
          this.totalRecords = r.data.totalRecords;
          if (this.defaultSelect && !this.isInit && !this.allowMultiple) {
            //defaultselect = model(sys_user)
            let sys_user = this.defaultSelect;
            // let selectUser = this.tableData.find(o => o.user_id == sys_user.id);

            // // this.selecteds = this.defaultSelect;
            // this.$nextTick(() => {
            //   $(
            //     `li.media[data-staffCode='${selectUser.staff_code}']`
            //   ).toggleClass("selected");
            //   this.selecteds.push(selectUser);
            // });

            this.isInit = true;
          }
          if(this.isShowSelected){
            this.tableData = _.cloneDeep(this.selecteds);
            this.totalRecords = this.tableData.length
          }
          this.hideLoading();
        },
        function(r) {
          this.hideLoading();
        }
      );
    },
    showLoading() {
      $(this.$refs.formPanel).block({
        message: '<i class="icon-spinner2 spinner"></i>',
        overlayCSS: {
          backgroundColor: "#fff",
          opacity: 0.8,
          cursor: "wait",
          "box-shadow": "0 0 0 1px #ddd"
        },
        css: {
          border: 0,
          padding: 0,
          backgroundColor: "none"
        }
      });
    },
    hideLoading() {
      $(this.$refs.formPanel).unblock();
    },
    formatEntity(r) {
      return r.description + " ver." + r.wf_version + " id:" + r.id;
    },
    selectRecord(r, e) {
      if (this.selecteds.find(o=>o.id==r.id)) {
        this.selecteds = $.grep(this.selecteds, function(value) {
          return value.id !== r.id;
        });
      } else {
        if (this.allowMultiple) {
          this.selecteds.push(r);
        } else {
          this.selecteds = [r];
          $(e.target)
            .closest(".media-list")
            .find(".media")
            .removeClass("selected");
        }
      }
      $(e.target)
        .closest(".media")
        .toggleClass("selected");
      e.preventDefault();
    },
    isSelected(id) {
      var found = false;
      if (this.id) {
        found = this.selecteds.find(o => o.id === id) ? true : false;
      }
      return found;
    },
    applyRecord() {
      this.$emit("applyRecord", this.selecteds);
    },
    notInExclude(d) {
      var found = false;
      if (this.excludeUsers) {
        $.each(this.excludeUsers, function(i, s) {
          if (d.staff_code === s) {
            found = true;
            return false;
          }
        });
      }
      return !found;
    },
    setSelected(value){
      if (value) {
        if (jQuery.type(value) === "array") {
          this.selecteds = value;
        } else {
          this.selecteds = [value];
        }
      } else {
        this.selecteds = [];
      }
    },
    clearFilter() {
      this.filter = {};
      this.getData();
    }
  },
  computed: {
    pages: function() {
      var a = [];
      for (
        var i = Math.max(this.currentPage + 1 - this.pagingPages / 2, 1);
        i <=
        Math.min(
          this.currentPage + 1 + this.pagingPages / 2,
          Math.ceil(this.totalRecords / this.pageSize)
        );
        i++
      ) {
        a.push(i);
      }
      return a;
    }
  },
  watch: {
    value: function(value) {
      this.setSelected(value);
    },
    excludeUsers: function(value) {}
  }
};
</script>
<style>
.media-list .media {
  cursor: pointer;
}
.media-list .media.selected {
  background: #e8f5e9;
}
</style>
